import React, { useState, useEffect } from "react";
import HourlyViewScheduleEvent from "./HourlyViewScheduleEvent";

const hours = [
	"06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"
]

const HourlyScheduleView = (props) => {
    console.log("entity schedules")
    console.log(props.entitySchedules)
    return (
        <div className="day-view">
            <div className="hour-label-container">
                <div className="schedule-label"></div>
                {
                    hours.map(hour => {
                        return <div key={hour} className="hour-label">
                            { hour }
                        </div>
                    })
                }
            </div>
            {
                props.schedules && props.schedules.map(s => {
                    return <div key={s.id} className="schedule-row">
                        <div className="schedule-label">{s.name}</div>
                        {
                            hours.map(hour => {
                                return <div key={hour} className="hour" onClick={() => props.openModalClick(s, hour)} />
                            })
                        }
                        {
                            props.events && props.events.filter(e => e.schedule_id === s.id).map(e => {
                                return <HourlyViewScheduleEvent key={e.id} event={e} openEvent={props.showModal}/>
                            })
                        }
                    </div>
                })
            }
            {
                props.entitySchedules  ?
                <div className="schedule-entities-container">
                {
                    Object.keys(props.entitySchedules).map(site => {
                        return (
                            <div className="schedule-entity">
                                <div key={site} className="schedule-row site-label">{site}</div>

                                {
                                    Object.keys( props.entitySchedules[site]).map(entity => {
                                        let schedule = props.entitySchedules[site][entity][0] //THis will be a blended schedule and not an array eventually
                                        return <div key={schedule.id} className="schedule-row">
                                            <div className="schedule-label">{entity}</div>
                                                {
                                                    hours.map(hour => {
                                                        return <div key={hour} className="hour" />
                                                    })
                                                }
                                                {
                                                    schedule.blocks.map(e => {
                                                        return <HourlyViewScheduleEvent key={e.id} event={e} openEvent={props.showModal}/>
                                                    })
                                                }
                                        </div>
                                    })

                                }
                            </div>
                        )
                    })
                }
                </div> : null
            }


        </div>
    )

}

export default HourlyScheduleView;